<script lang="ts" setup>
import { TaskModel } from '@/components/tasks-kanban/models';
import { ListItemModel } from '@/components/tir-pm-list/models';
import { computed, PropType, ref } from 'vue';
import TaskCardItemWrapper from './task-card-item-wrapper.vue';

/**Параметры */
const props = defineProps({
  /**Задача */
  task: { type: Object as PropType<TaskModel> },
  /**Данные об элемнте */
  element: { type: Object as PropType<ListItemModel> },
});

/**Оценка времени */
const estimateTime = computed(() => {
  if (props.task.EstimateTime) {
    return props.task.EstimateTime?.toFixed(2).replace('.', 'ч ') + 'м';
  } else {
    return '-';
  }
});
</script>
<template>
  <TaskCardItemWrapper :element="element">
    <span class="work-time-empty" v-text="estimateTime" />
  </TaskCardItemWrapper>
</template>
<style lang="scss" scoped>
.work-time-empty {
  font-size: 0.875rem;
}
</style>
